import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import ApiService from '../../../services/api.service';
import { URL_CONSTANTS } from '../../../constants/urlConstants';

const initialState = {
  userCategoryList: [],
  status: false,
  error: null,
};

export const fetchUserCategoryList = createAsyncThunk(
  'master/fetchUserCategoryList',
  async () => {
    const response = await ApiService.getWithDiffBaseUrl(
      `/auth/user/manage/category`,
      {},
      URL_CONSTANTS.USER_META.baseUrl
    );
    return response?.data || [];
  }
);

const userCategorySlice = createSlice({
  name: 'userCategoryList',
  initialState,
  reducers: {
    clearUserCategoryList: state => {
      state.userCategoryList = [];
      state.status = false;
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchUserCategoryList.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchUserCategoryList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.userCategoryList = action?.payload || [];
      })
      .addCase(fetchUserCategoryList.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const { clearUserCategoryList } = userCategorySlice.actions;

export const userCategoryReducer = userCategorySlice.reducer;
